module.exports = __webpack_public_path__ + "img/horizontal_3_3_7042.8343a9a3.png";